import React, { useState } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Button from '@material-ui/core/Button';
import { Checkbox, FormControlLabel } from '@material-ui/core';

import { CardPaymentForm, CARD_PAYMENT_CONFIG } from './CardPaymentForm';
import { ECheckPaymentForm, ECHECK_PAYMENT_CONFIG } from './ECheckPaymentForm';
import {
  PAYMENT_FORM_TYPE,
  PAYMENT_FORM_DIFFERENT_BILLING_ADDRESS,
} from '../constants';
import { TermsAndConditions } from '../../TermsAndConditions/TermsAndConditions';
import { AddressForm } from '../../ApplicationForm/AddressForm';

import cn from './styles.module.scss';
import {
  COUNTRIES,
  FORM_CONFIG,
  USA_STATES,
} from '../../ApplicationForm/constants';

const initialForm = {
  [PAYMENT_FORM_DIFFERENT_BILLING_ADDRESS.member_is_different_billing_address
    .key]: false,
  [PAYMENT_FORM_DIFFERENT_BILLING_ADDRESS.member_billing_country.key]:
    COUNTRIES.usa.value,
  [PAYMENT_FORM_DIFFERENT_BILLING_ADDRESS.member_billing_state_or_province.key]:
    USA_STATES[0],
  [PAYMENT_FORM_DIFFERENT_BILLING_ADDRESS.member_billing_address.key]: '',
  [PAYMENT_FORM_DIFFERENT_BILLING_ADDRESS.member_billing_zipcode.key]: '',
  [PAYMENT_FORM_DIFFERENT_BILLING_ADDRESS.member_billing_city.key]: '',
};

export const PaymentForm = ({ onSubmit, paymentInProgress }) => {
  const [tabValue, setTabValue] = useState(PAYMENT_FORM_TYPE.eCheckPayment);
  const [agreed, setAgreed] = useState(false);
  const [diffBillingAddressForm, setDiffBillingAddressForm] =
    useState(initialForm);

  const handleSubmit = (event) => {
    event.preventDefault();
    let form = {
      paymentType: tabValue,
    };

    if (
      diffBillingAddressForm[
        PAYMENT_FORM_DIFFERENT_BILLING_ADDRESS
          .member_is_different_billing_address.key
      ]
    ) {
      form = {
        ...form,
        ...diffBillingAddressForm,
      };
    }

    Object.keys(
      tabValue === PAYMENT_FORM_TYPE.eCheckPayment
        ? ECHECK_PAYMENT_CONFIG
        : CARD_PAYMENT_CONFIG,
    ).forEach((key) => {
      form[key] = event.target.elements.namedItem(key).value;
    });
    onSubmit(form);
  };

  const handleTabChange = (event, value) => {
    setTabValue(value);
  };

  const handleBillingAddressToggleChange = (event, checked) => {
    setDiffBillingAddressForm((prevState) => ({
      ...prevState,
      [PAYMENT_FORM_DIFFERENT_BILLING_ADDRESS
        .member_is_different_billing_address.key]: checked,
    }));
  };

  const handleBillingAddressChange = (form) => {
    const address = {
      [FORM_CONFIG.member_billing_country.key]: form.country,
      [FORM_CONFIG.member_billing_state_or_province.key]: form.state,
      [FORM_CONFIG.member_billing_address.key]: form.address,
      [FORM_CONFIG.member_billing_city.key]: form.city,
      [FORM_CONFIG.member_billing_zipcode.key]: form.zipcode,
    };

    setDiffBillingAddressForm((prevState) => ({
      ...prevState,
      ...address,
    }));
  };

  const addressFormValues = {
    country: {
      value:
        diffBillingAddressForm[
          PAYMENT_FORM_DIFFERENT_BILLING_ADDRESS.member_billing_country.key
        ],
      required:
        PAYMENT_FORM_DIFFERENT_BILLING_ADDRESS.member_billing_country.required,
    },
    state: {
      value:
        diffBillingAddressForm[
          PAYMENT_FORM_DIFFERENT_BILLING_ADDRESS
            .member_billing_state_or_province.key
        ],
      required:
        PAYMENT_FORM_DIFFERENT_BILLING_ADDRESS.member_billing_state_or_province
          .required,
    },
    address: {
      value:
        diffBillingAddressForm[
          PAYMENT_FORM_DIFFERENT_BILLING_ADDRESS.member_billing_address.key
        ],
      required:
        PAYMENT_FORM_DIFFERENT_BILLING_ADDRESS.member_billing_address.required,
      label: 'Address:',
    },
    city: {
      value:
        diffBillingAddressForm[
          PAYMENT_FORM_DIFFERENT_BILLING_ADDRESS.member_billing_city.key
        ],
      required:
        PAYMENT_FORM_DIFFERENT_BILLING_ADDRESS.member_billing_city.required,
    },
    zipcode: {
      value:
        diffBillingAddressForm[
          PAYMENT_FORM_DIFFERENT_BILLING_ADDRESS.member_billing_zipcode.key
        ],
      required:
        PAYMENT_FORM_DIFFERENT_BILLING_ADDRESS.member_billing_zipcode.required,
    },
  };

  return (
    <div className={cn.paymentForm}>
      <div>
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              checked={
                diffBillingAddressForm[
                  PAYMENT_FORM_DIFFERENT_BILLING_ADDRESS
                    .member_is_different_billing_address.key
                ]
              }
              onChange={handleBillingAddressToggleChange}
            />
          }
          label="Use different billing address"
        />
        {diffBillingAddressForm[
          PAYMENT_FORM_DIFFERENT_BILLING_ADDRESS
            .member_is_different_billing_address.key
        ] && (
          <div>
            <AddressForm
              values={addressFormValues}
              onChange={handleBillingAddressChange}
            />
          </div>
        )}
      </div>
      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        indicatorColor="primary"
        className={cn.tabs}
      >
        <Tab value={PAYMENT_FORM_TYPE.eCheckPayment} label="eCheck payment" />
        <Tab value={PAYMENT_FORM_TYPE.cardPayment} label="Card payment" />
      </Tabs>
      <form onSubmit={handleSubmit} className={cn.form}>
        {tabValue === PAYMENT_FORM_TYPE.eCheckPayment && <ECheckPaymentForm />}
        {tabValue === PAYMENT_FORM_TYPE.cardPayment && <CardPaymentForm />}
        <div className={cn.termbox}>
          <TermsAndConditions />
        </div>
        <FormControlLabel
          control={<Checkbox checked={agreed} color="primary" />}
          label="I have read and agree to the terms and conditions stated above"
          onChange={(event, checked) => setAgreed(checked)}
        />
        <Button
          type="submit"
          disabled={!agreed || paymentInProgress}
          variant="contained"
          className={cn.submitButton}
          color="primary"
        >
          Purchase Membersip Plan
        </Button>
      </form>
    </div>
  );
};
